import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import YouTube, { YouTubeProps } from 'react-youtube';

import { VideoEmbed as ArticleVideoEmbedProps } from 'lib/sanity/types';
import { BlockSerializerUbiContext } from 'lib/sanity/ui/BlockSerializerUbiProvider';

const VideoContainer = styled.div`
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  padding-bottom: 56.25%;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    border: 0;
    height: 100%;
    width: 100%;
  }
`;

const youtubeOptions: YouTubeProps['opts'] = {
  playerVars: {
    modestbranding: 1,
  },
};

interface Props {
  videoEmbed: ArticleVideoEmbedProps;
}

const ArticleVideoEmbed = ({ videoEmbed }: Props) => {
  const title = videoEmbed?.video?.title;
  const vimeoId = videoEmbed?.video?.vimeoId;
  const youtubeId = videoEmbed?.video?.youtubeId;

  const ubi = useContext(BlockSerializerUbiContext);
  useEffect(() => {
    const videoId = vimeoId || youtubeId;

    if (videoId) {
      ubi.logVideoImpression(videoId);
    }
  }, [ubi, vimeoId, youtubeId]);

  if (vimeoId) {
    return (
      <VideoContainer>
        <iframe title={title} src={`https://player.vimeo.com/video/${vimeoId}?wmode=opaque`} />
      </VideoContainer>
    );
  }

  if (youtubeId) {
    return (
      <VideoContainer>
        <YouTube title={title} videoId={youtubeId} opts={youtubeOptions} />
      </VideoContainer>
    );
  }

  return null;
};

export default ArticleVideoEmbed;
